import { css } from "@emotion/css";

const styles = {
  invoiceItem: css`
    height: 80px;
  `,
};

export default styles;
